<ng-container *transloco="let t; prefix: 'approval.summary'">
  <div class="decision-box">
    <div class="decision-header">
      @if (admissionState$() | async; as state) {
        @if (state === 'PENDING') {
          <p class="header-subtitle">{{ t('pleaseCheck') }}</p>
        } @else {
          <p class="header-subtitle">Anfrage wurde bereits bearbeitet</p>
        }
      }
    </div>
    <div class="decision-content">
      @if (admissionState$() | async; as state) {
        @if (state === 'PENDING') {
          <div class="reasoning-section">
            <htx-textarea-field
              [ctrl]="approvalForm().controls['reasoning']"
              [label]="t('reasoning.label')"
              [rows]="3"
            ></htx-textarea-field>
          </div>

          <div class="action-buttons">
            <htx-button (click)="onApprove()" [fullWidth]="true" icon="check" variant="success" [disabled]="isReasoningEmpty()">{{ 'button.approve' | transloco }}</htx-button>
            <htx-button (click)="onReject()" [fullWidth]="true" icon="close" variant="danger" [disabled]="isReasoningEmpty()">{{ 'button.reject' | transloco }}</htx-button>
          </div>
        } @else {
          <div class="decision-status-section">
            <div class="decision-status-badge" [ngClass]="{
              'decision-status-badge--approved': state === 'APPROVED',
              'decision-status-badge--rejected': state === 'REJECTED'
            }">
              @if (state === 'APPROVED') {
                <span class="status-icon">✓</span>
                <span class="status-text">Anfrage wurde genehmigt</span>
              } @else if (state === 'REJECTED') {
                <span class="status-icon">✕</span>
                <span class="status-text">Anfrage wurde abgelehnt</span>
              }
            </div>
          </div>

          <div class="reasoning-section">
            <label for="reasoningReadonly" class="reasoning-label">Begründung der Entscheidung</label>
            <div id="reasoningReadonly" class="reasoning-readonly">
              {{ (existingReasoning$() | async) || 'Keine Begründung angegeben' }}
            </div>
          </div>
        }
      }
    </div>
  </div>
</ng-container>
